<template>
  <div class="app">
     <div
      id="mm3D"
      style="
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0px;
        top: 0px;
        z-index: 0;
      "
    >
      <iframe
        id="iframeid1"
        src=""
        width="100%"
        height="100%"
        style="border: none"
      ></iframe>
    </div>
    <div
      id="mmGIS"
      style="
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0px;
        top: 0px;
        z-index: 0;
      "
    >
      <iframe
        id="iframeid"
        src="mmGIS/index.html"
        width="100%"
        height="100%"
        style="border: none"
      ></iframe>
    </div> 

    <router-view></router-view>
  </div>
</template>

<script>
import autofit from "autofit.js"
export default {
  // 1.引入插件

  created() {
    if (this.$router.path !== "/loding") this.$router.replace("/");
  },
};
</script>

<style lang="scss" scoped>
</style>
